import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { Hero } from '@/components/landing/hero'
import { AboutSection } from '@/components/landing/about-section'
import { SpeakersSection } from '@/components/landing/speakers-section'
import { ScheduleSection } from '@/components/landing/schedule-section'
import { PartnersSection } from '@/components/landing/partners-section'
import { GallerySection } from '@/components/landing/gallery-section'
import { TicketsSection } from '@/components/landing/tickets-section'
import { LocationSection } from '@/components/landing/location-section'
import { FaqSection } from '@/components/landing/faq-section'
import { CtaSection } from '@/components/landing/cta-section'

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo ogImage='/images/hero.png' />

            <Hero />
            <AboutSection />
            <SpeakersSection />
            <ScheduleSection />
            <PartnersSection />
            <GallerySection />
            <TicketsSection />
            <LocationSection />
            <FaqSection />
            <CtaSection />
        </Layout>
    )
}

export default Home
